import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const AppDevelopmentJobsGhazi = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`App Development Jobs in Ghaziabad | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest App Development Jobs in Ghaziabad NCR. Explore Android, iOS, and cross-platform app developer openings for freshers and experienced candidates. Apply today with JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="app development jobs in Ghaziabad , android developer jobs Ghaziabad , iOS developer jobs Ghaziabad , mobile app developer jobs Ghaziabad  NCR, react native developer jobs Ghaziabad , flutter developer jobs Ghaziabad , app developer fresher jobs Ghaziabad , hybrid app developer jobs Ghaziabad , full stack app developer jobs Ghaziabad "
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/appdevelopment-jobs-in-ghaziabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          App Development Jobs in Ghaziabad  – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Searching for <strong>App Development Jobs in Ghaziabad  NCR</strong>? Explore the latest openings for Android, iOS, and hybrid app developers. Whether you’re a fresher or an experienced developer, find the perfect opportunity to build your career in app development today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring App Developers in Ghaziabad 
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Tech Mahindra</li>
          <li>Wipro</li>
          <li>TCS</li>
          <li>Accenture</li>
          <li>Infosys</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular App Developer Roles in Ghaziabad 
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Android Developer Jobs in Ghaziabad </li>
          <li>iOS Developer Jobs in Ghaziabad </li>
          <li>React Native Developer Jobs in Ghaziabad </li>
          <li>Flutter Developer Jobs in Ghaziabad </li>
          <li>Full Stack App Developer Jobs in Ghaziabad </li>
          <li>Mobile App UI/UX Developer Jobs in Ghaziabad </li>
          <li>App Tester Jobs in Ghaziabad </li>
          <li>Hybrid App Developer Jobs in Ghaziabad </li>
          <li>Junior App Developer Jobs in Ghaziabad </li>
          <li>Senior App Developer Jobs in Ghaziabad </li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> — your trusted job portal for verified <strong>App Development Jobs in Ghaziabad</strong>. Apply directly without registration and find your next opportunity today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default AppDevelopmentJobsGhazi;
